/**
 * Locale codes keyed by the app's language (`en` / `fr` / `es`, as
 * `useApplication().localization.language`).
 */

/**
 * Underscore locale codes. Not imported: Contentful and product details take `Locales` from
 * `@ryerson/frontend.header-footer` instead.
 */
export enum Locales {
	en = "en_US",
	es = "es_MX",
	fr = "fr_CA",
}

/**
 * Lower-case hyphenated locale codes, used to pick the translated entry out of API data keyed by
 * locale (for example a product's `processingAttribute["en-us"]` in
 * `components/Shared/DisplayDefineCut/DefineCutDisplay.tsx`).
 */
export enum LowerCaseLocales {
	en = "en-us",
	es = "es-mx",
	fr = "fr-ca",
}